import AuditLog from "./AuditLog";

export default AuditLog;